/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S4_TitleInputs */

const en_guide_json_vs_yaml_xml_s4_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML: The Enterprise Standard`)
};

const ko_guide_json_vs_yaml_xml_s4_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML: 엔터프라이즈 표준`)
};

const ja_guide_json_vs_yaml_xml_s4_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML：エンタープライズの標準`)
};

/**
* | output |
* | --- |
* | "XML: The Enterprise Standard" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S4_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s4_title = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S4_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S4_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s4_title(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s4_title(inputs)
	return ja_guide_json_vs_yaml_xml_s4_title(inputs)
});